module.exports = __webpack_public_path__ + "img/LoaderPlane.c385d0e0.png";